export default {"src":"/_next/static/media/units.e6b60309.svg","height":625,"width":1920,"blurWidth":0,"blurHeight":0};